// Keep stories arrows in sync with the selected media, not scroll-edge events.
// Desktop grids can emit both edge events and leave the stock arrows stale.
await customElements.whenDefined('carousel-navigation');

if (!customElements.get('product-gallery-stories-navigation')) {
  class ProductGalleryStoriesNavigation extends customElements.get('carousel-navigation') {
    connectedCallback() {
      super.connectedCallback();
      this.storiesAbortController = new AbortController();
      const options = { signal: this.storiesAbortController.signal };
      const stage = this.closest('.product-gallery__stage');
      this.previousButton = stage.querySelector('.product-gallery__arrow--prev');
      this.nextButton = stage.querySelector('.product-gallery__arrow--next');
      this.previousButton.addEventListener('click', () => this.carousel.previous(), options);
      this.nextButton.addEventListener('click', () => this.carousel.next(), options);
      this.carousel.addEventListener('carousel:filter', () => this.syncArrows(), options);
      this.syncArrows();
    }

    disconnectedCallback() {
      super.disconnectedCallback();
      this.storiesAbortController?.abort();
    }

    onNavigationChange(index) {
      super.onNavigationChange(index);
      this.syncArrows();
    }

    syncArrows() {
      if (!this.previousButton || !this.nextButton) return;
      const index = this.selectedIndex;
      this.previousButton.disabled = index <= 0;
      this.nextButton.disabled = index < 0 || index >= this.items.length - 1;
    }
  }

  customElements.define('product-gallery-stories-navigation', ProductGalleryStoriesNavigation);
}
